/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectSharing
 */
export interface ReadOnlyMonitoredObjectSharing {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectSharing
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectSharing
     */
    readonly deleted?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectSharing
     */
    monitoredObject: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectSharing
     */
    receiver: number;
}

export function ReadOnlyMonitoredObjectSharingFromJSON(json: any): ReadOnlyMonitoredObjectSharing {
    return ReadOnlyMonitoredObjectSharingFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectSharingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectSharing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'monitoredObject': json['monitored_object'],
        'receiver': json['receiver'],
    };
}

export function ReadOnlyMonitoredObjectSharingToJSON(value?: ReadOnlyMonitoredObjectSharing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'monitored_object': value.monitoredObject,
        'receiver': value.receiver,
    };
}


